<template>
  <button
    :class="{ [$style.root]: true, [$style[type]]: !!type }"
    @click="$emit('click')"
  ><slot/></button>
</template>

<script>
export default {
  props: ['type']
}
</script>

<style lang="scss" module>
.root {
  display: block;
  width: 100%;
  border: 0;
  outline: 0;
  padding: 10px;
  background-color: rgb(39, 120, 173);
  color: #fff;
  cursor: pointer;
  transition: .2s;

  &:hover {
    background-color: rgb(24, 96, 145);
  }
}

.bordered {
  background-color: #fff;
  border: 1px solid rgb(39, 120, 173);
  color: rgb(39, 120, 173);
  padding: 10px;
  margin: 10px 0;

  &:hover {
    background-color: #fff;
    border-color: rgb(24, 96, 145);
  }
}
</style>